module.exports = __webpack_public_path__ + "img/img_jinbi1@2x.34ce1c7c.png";